export default __webpack_public_path__ + "static/media/female@2x.6ef26138.png";